/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const mastercard_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10.48 8.943A6.72 6.72 0 0 0 9.75 12a6.71 6.71 0 0 0 .702 3M12 6.969a6.75 6.75 0 1 1 0 10.062M12 6.97a6.75 6.75 0 1 0 0 10.062M12 6.97A6.733 6.733 0 0 1 14.25 12c0 2-.87 3.795-2.25 5.031"
    />
  </svg>
)
export default mastercard_medium
